import { ENV } from '@/configs/env';

let BASE_URL = 'https://dsim568-api.intra.xiaojukeji.com';

// 开发环境
if (process.env.BUILD_ENV === ENV.DEV) {
    BASE_URL = 'https://dsim568-api.intra.xiaojukeji.com';
}

// 正式环境
if (process.env.BUILD_ENV === ENV.ONLINE) {
    BASE_URL = 'https://market-growth-api.didifinance.com';
}

// 预发环境
if (process.env.BUILD_ENV === ENV.PRE) {
    BASE_URL = 'https://market-pre-growth-api.intra.didifinance.com';
}

// sim环境
if (process.env.BUILD_ENV === ENV.SIM) {
    BASE_URL = `${window.location.origin.replace('page', 'api')}`;
}

// 根据本机启动网址变化
// const MOCK_URL = 'http://192.168.3.20:9200/data/mxcreditcardmsireward';
// const MOCK_URL = 'http://172.16.3.245:9200/data/mxcreditcardmsireward';
// BASE_URL = MOCK_URL;

// 活动领取接口
export const API_JOIN_ACTIVITY = `${BASE_URL}/marketing-portal/landing-page/v2/activity/recall`;

// 首页活动id请求接口
export const API_GET_ACTIVITY = `${BASE_URL}/marketing-portal/landing-page/v2/query/config`;
